import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { Router } from '@services/route.service';
import { User as UserService } from '@services/user.service';

@Component({
  selector: 'lgb-forgot',
  imports: [
    UiModule,
    FormsModule,
    RouterModule
  ],
  templateUrl: './forgot.html',
  styleUrl: './forgot.css',
})
export class Forgot {
  //services
  readonly userS=inject(UserService);
  readonly router=inject(Router);

  //model
  readonly mail=signal<string|null>(null);

  //ui
  readonly loading=signal<boolean>(false);
  readonly msg=signal<string|null>(null);
  readonly error=signal<string|null>(null);

  forgot(){
    this.loading.set(true);
    this.userS.forgot(this.mail()).subscribe(() => {
      this.msg.set('Consultez vos e-mails pour la suite');
      this.loading.set(false);
    });
  }

}
